import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { SUPPORTED_UI_LOCALES } from './locale';

const App: React.FC = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppRoutes />
  </BrowserRouter>
);

export default App;
export { SUPPORTED_UI_LOCALES };
